<template>
  <svg
    class="icon"
    width="17"
    height="29"
    viewBox="0 0 17 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3051 16.6188V3.13744C16.3051 3.13744 16.637 0 12.545 0H3.77021C-0.321793 0 0.010089 3.13744 0.010089 3.13744V16.6188C0.010089 16.6188 -0.256146 19.7871 1.94668 19.7871H5.51897V21.5053H7.34432V25.2808H5.51897V27.0933H7.34432V28.7553H9.08762V27.0933H10.7981V25.2808H9.08762V21.5053H10.9111V19.7871H14.3686C16.8376 19.7871 16.3051 16.6188 16.3051 16.6188ZM12.0964 18.3334H10.9111V18.0308H5.51715V18.3334H4.32821C1.50903 18.3334 1.63303 15.8757 1.63303 15.8757V8.88488H5.38403V7.25181H1.63303V5.25987H5.35485V3.62681H1.72968C1.91932 2.85831 2.50103 1.56781 4.32638 1.56781H12.0964C14.5582 1.56781 14.7934 4.18687 14.7934 4.18687V15.8757C14.7953 15.8757 15.0141 18.3334 12.0964 18.3334Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'BloodPressure',
};
</script>
